gridItems = $( ".grid__item" );

$(".filter-label").each( function( index ) {
  this.value = filters[`filter${index}`];

  switch (this.value) {
    case 'Classic':
    case 'Classique':
      $(this).css('order', '1');
      break;
    case 'Discovery':
    case "Découverte":
      $(this).css('order', '2');
      break;
    case 'Exception':
      $(this).css('order', '3');
      break;
    case 'Aventure':
    case 'Adventure':
      $(this).css('order', '4');
      break;
    case 'Boxes':
    case 'Coffrets':
      $(this).css('order', '5');
      break;
  };
});

$(".filter-label").on( "click", function () {
  if ( $(this).hasClass("underlined") ) {
    $(this).removeClass("underlined")
    
    gridItems.each( function() {
      $(this).removeClass("hidden")
    });
    
  } else {
    $(".filter-label").each( function() {
      $(this).removeClass("underlined");
    });

    gridItems.each( function() {
      $(this).removeClass("hidden");
    });
  
    $(this).addClass("underlined")

    switch (this.value) {
      case 'Adventure':
        label = 'Aventure';
        break;
      case 'Boxes':
        label = 'Coffrets';
        break;
      case 'Classic':
        label = 'Classique';
        break;
      case 'Discovery':
        label = 'Découverte';
        break;
      case 'Exception':
        label = 'Exception';
        break;
      default: label = this.value
    }


    selectedProducts = []
    
    $.each( products, function( i ) {
      if ( jQuery.inArray( label, this.tags ) != -1) {
        product = this;
        gridItems.each( function( index ) {
          if ( this.innerText.indexOf( product.title ) != -1 ) {
            selectedProducts.push(this);
          };
        })
      };
    });
    notSelectedProducts = jQuery.map( $(gridItems), function( e, i ) {
      if ( $.inArray( e, selectedProducts) === -1 ) {
        return e
      };
    });
    $.each( notSelectedProducts, function() {
      $(this).addClass("hidden");
    });
  };
});


